import React from 'react';
import Button from 'app/common/react/components/growth/unauth/Button/Button';
import defaultAvatar from 'app/common/images/sendPinAvatar-76x.png';
import i18n from 'app/common/lib/i18n';
import IconVerifiedIdentity from 'app/common/react/components/common/UserRep/IconVerifiedIdentity';
import PrettyNumber from 'app/common/react/i18n/PrettyNumber';
import PropTypes from 'prop-types';
import { Box, Text } from 'gestalt';

const styles = {
  pinnerHero: {
    display: 'inline-block',
    position: 'relative',
    width: '236px',
  },
  pinnerImage: {
    borderRadius: '50%',
    width: '236px',
    height: '236px',
  },
  userInfo: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    padding: '5px 8px',
  },
  userFullName: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    color: '#333',
    display: 'inline-block',
    fontSize: '18px',
    fontWeight: 'bold',
    letterSpacing: '-.2px',
    marginTop: '7px',
    marginBottom: '3px',
  },
  userFollowerCount: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    color: '#aaa',
    fontSize: '11px',
    letterSpacing: '-.1px',
  },
  followerValue: {
    fontWeight: 'bold',
  },
  userDescription: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    color: '#333',
    fontSize: '13px',
    lineHeight: '17px',
    marginTop: '8px',
    wordWrap: 'break-word',
  },
  userWrapper: {},
  followButton: {
    width: '100%',
    marginBottom: '5px',
  },
};

export const PinnerHeroUserPropType = PropTypes.shape({
  full_name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  image_xlarge_url: PropTypes.string,
  username: PropTypes.string.isRequired,
  verified_identity: PropTypes.shape({
    verified: PropTypes.bool,
  }),
});

function UnauthPinnerHero(props) {
  const { user, description, followerCount, verified } = props;
  const { username, full_name, image_xlarge_url } = user;
  const imageURL = image_xlarge_url || defaultAvatar;

  return (
    <div style={styles.pinnerHero}>
      <a href={`/${username}/`} style={styles.userWrapper}>
        <img style={styles.pinnerImage} src={imageURL} alt={i18n._('Profile image')} />
      </a>
      <div style={styles.userInfo}>
        <div style={styles.userFullName}>
          <Box alignItems="center" justifyContent="center" display="flex">
            <Text size="lg" bold truncate>
              {full_name}
            </Text>
            {verified && (
              <Box deprecatedMargin={{ left: 1 }}>
                <IconVerifiedIdentity />
              </Box>
            )}
          </Box>
        </div>
        {followerCount && (
          <div style={styles.userFollowerCount}>
            <span style={styles.followerValue}>
              <PrettyNumber value={followerCount} shortform />
            </span>
            <span>
              &nbsp;
              {i18n._('Followers')}
            </span>
          </div>
        )}
        {description && <div style={styles.userDescription}>{description}</div>}
        <Button
          className={'UnauthPinnerHero__follow red'}
          onClick={props.showSignupModal}
          styleOverrides={styles.followButton}
        >
          {i18n._('Follow')}
        </Button>
      </div>
    </div>
  );
}

UnauthPinnerHero.propTypes = {
  user: PinnerHeroUserPropType.isRequired,
  description: PropTypes.string,
  followerCount: PropTypes.number,
  showSignupModal: PropTypes.func,
  verified: PropTypes.bool,
};

export default UnauthPinnerHero;
